import { QuarterlyDashboardEffects } from './quarterly-dashboard.effects'
import { QUARTERLY_DASHBOARD_FACADE, QuarterlyDashboardFacade } from './quarterly-dashboard.facade'
import { quarterlyDashboardState } from './quarterly-dashboard.reducer'
import { quarterlyDashboardFeatureKey } from './quarterly-dashboard.state'

export * from './quarterly-dashboard.constant'
export * from './quarterly-dashboard.facade'
export * from './quarterly-dashboard.columns'

export const QUARTERLY_DASHBOARD_REDUCER = { [quarterlyDashboardFeatureKey]: quarterlyDashboardState }
export const QUARTERLY_DASHBOARD_PROVIDERS = [
  { provide: QUARTERLY_DASHBOARD_FACADE, useClass: QuarterlyDashboardFacade },
]
export const QUARTERLY_DASHBOARD_EFFECTS = [QuarterlyDashboardEffects]
